var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AppBody"},[_c('el-container',[_c('el-header',[_c('AppTopNav')],1),_c('el-container',{staticClass:"container2"},[_c('el-aside',{attrs:{"width":"230px"}},[_c('AppNav')],1),_c('el-main',[(_vm.initFinish)?_c('router-view',{ref:"routerView"}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }